import { IConvertGameList, ISlotConverter } from '../../types/converter';
import { ISlotViewItem } from '../../types/interfaces/Slots/Slots';
import { IGetGameUrl } from '../../types/slot';
import { CasinoType } from 'modules/Casino/types/configuration';

class Converter implements ISlotConverter {
  convertGameList = ({
    data,
  }: IConvertGameList<
    Array<{
      gameCode: string;
      imageSquare: string;
      gameName: string;
    }>
  >): ISlotViewItem[] =>
    (data ?? []).map(game => ({
      id: game.gameCode,
      gameId: game.gameCode,
      gameName: game.gameName,
      description: game.gameName,
      routeProvider: 'pgsoft',
      provider: 'pgsoft',
      type: CasinoType.slots,
      tab: [],
      imageUrl: game.imageSquare,
    }));

  convertGameUrl = ({ data }: IGetGameUrl<{ url: string }, unknown>) => data.url;
}

export default Converter;
